<template>
  <div class="col-12">
    <div class="col-12" style="padding-left:2em">
      <img class="logo-menu" src="../../public/images/logo.png" alt="logo esmo">
    </div>
    <div class="col-12" style="text-align: center;">
      <div>
        <CircularProgressBar :progress="completionPercentage"  :value="completedRecommendations" :total="totalRecommendations"/>
      </div>
    </div>
  </div>
  <!-- contenitore -->
    <div class="col-12 container-menu-steps">
      <div class="grid col-12 without-padding-margin">
        <div class="grid col-12 without-padding-margin">
          <div :class="'col-12 menu-step-label home'"
               @click="goToHome">
            <i class="fa fa-home"></i> <b>Home</b>
          </div>
        </div>
      </div>
      <!-- primo giro -->
      <div class="grid col-12 without-padding-margin"
           :class="(step.breadcrumb.length <= 1 ? 'box' : '')"
           v-for="(step, index) of steps" v-bind:key="index"
           :style="index === 0 ? 'border-top: 0;border-bottom: 0;' : '' ">
        <div class="grid col-12 without-padding-margin"
             :class="dynamicBorderMenu(index, currentStep)"
             v-if="step.breadcrumb.length <= 1">
          <div :class="(index === currentStep ? 'col-8 menu-step-label-active' : 'col-8 menu-step-label')"
               @click="goToStep(index)">
            <b>{{ step.code }}. {{ step.label }}</b>
          </div>
          <div class="col-4" :style="(index === currentStep ? 'margin-left:2.5px' : '')">
            <Tag :class="dynamicTagColorByCurrentStep(index)"
                 :value="step.children.length" rounded/>
          </div>
        </div>
        <!-- blocco methods -->
        <div class="col-12 blocco-methods"
            v-else-if="step.breadcrumb.length > 1 && !isSameSubGroup(index)">
          <div class="col-12">
            <b>{{ step.code }}. {{ step.breadcrumb[1] }} </b>
          </div>
        </div>
        <div class="grid col-12 container-submenu-steps"
             :class="dynamicBorderMenu(index, currentStep)"
             v-if="step.breadcrumb.length > 1">
          <div class="col-8 container-label-submenu"
               style="cursor: pointer;"
               :style="(index === currentStep ? 'margin-left:-2.5px' : '')"
               @click="goToStep(index)">
            <span>
              {{ step.label }}</span>
          </div>
          <div class="col-4" :style="(index === currentStep ? 'margin-left:2.5px' : '')">
            <Tag :class="dynamicTagColorByCurrentStep(index)"
                 :value="step.children.length"
                 rounded>
            </Tag>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {useApplicationStore} from "@/store/applicationStore";
import {useUserStore} from "@/store/userStore";
import {useLoadingStore} from "@/store/loadingStore";
import CircularProgressBar from "@/components/CircularProgressBar.vue";

export default {
  components: {CircularProgressBar},
  beforeCreate() {
    this.applicationStore = useApplicationStore()
    this.userStore = useUserStore()
    this.loadingStore = useLoadingStore()
  },
  data() {
    return {
      started: true,
      chartOptions: {
        cutout: '60%',
      }
    }
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            data: [this.completionPercentage, ( 100 - this.completionPercentage )],
            backgroundColor: ['#008F64', '#008F641A']
          },
        ],
      };
    },
    currentStep() {
      return this.applicationStore.currentStep;
    },
    recommendations() {
      return this.applicationStore.recommendations
    },
    steps() {
      return this.applicationStore.stepsProgress.steps != null
          ? this.applicationStore.stepsProgress.steps : []
    },
    totalRecommendations() {
      return this.steps.map(step => step.children.length).reduce((a, v) => a + v, 0)
    },
    completedRecommendations() {
      return this.steps.map(step => step.childrenCompleted).reduce((a, v) => a + v, 0)
    },
    notApplicableRecommendations() {
      return this.steps.map(step => step.childrenNotApplicable).reduce((a, v) => a + v, 0)
    },
    completionPercentage() {
      return Math.round(100 * this.completedRecommendations / this.totalRecommendations)
    }
  },
  watch: {},
  methods: {
    goToHome(){
      this.$router.push("/")
    },
    dynamicBorderMenu(index, currentStep){
      return index === currentStep ? 'menu-active' : ''
    },
    goToStep(index) {
      const previousIndex = index > 0 ? index-1 : 0;
      if (this.steps[index].childrenCompleted === this.steps[index].children.length
          || this.steps[previousIndex].childrenCompleted === this.steps[previousIndex].children.length) {
        this.$router.push('/recommendations')
        this.applicationStore.setCurrentStep(index)
      }
    },
    isSameSubGroup(index) {
      return this.steps[index].breadcrumb[1] === this.steps[index - 1].breadcrumb[1]
    },
    dynamicTagColorByCurrentStep(index) {
      if (this.steps[index].childrenCompleted === this.steps[index].children.length) {
        return 'current-tag'
      } else if (this.steps[index].childrenCompleted > 0) {
        return 'completed-tag'
      } else {
        return 'uncompleted-tag'
      }
    },
  },
}
</script>

<style scoped>
.uncompleted-tag {
  background: #f5f9f8;
  color: #008F644D;
  min-width: 4em;
  float: right;
}
.current-tag {
  background: #008F64;
  color: #fff;
  min-width: 4em;
  float: right;
}
.completed-tag {
  background: #008F644D;
  color: #008f64;
  min-width: 4em;
  float: right;
}
.menu-active {
  border-left:3px solid #008F64;
}
.blocco-methods{
  margin-bottom:.5em;
  padding: 0 0 0 1.5em;
}
.container-label-submenu{
  padding-left:3em;
}
.menu-step-label{
  padding-left:2em;
  cursor:pointer;
  padding-top:.7em;
}
.menu-step-label-active{
  padding-left:2em;
  cursor:pointer;
  padding-top:.7em;
  margin-left:-2.5px
}
.container-menu-steps{
  padding: 3em 0 0 0;
  margin: 0;
  overflow-y: auto;
  max-height:67vh;
}
.container-submenu-steps{
  padding: 0;
  margin: 0;
  overflow-y: auto;
  max-height:67vh;
}
.without-padding-margin{
  padding:0!important;
  margin:0!important;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #80808033;
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #008F6480;
  border-radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #008F64;
}

.logo-menu {
  width: 6em;
}
.home {
  border-bottom: 1px solid #008F641A;
}
.box {
  border-top: 1px solid #008F641A;
  border-bottom: 1px solid #008F641A;
  margin-top: 0;
  padding-top: 21.5em
}

</style>
